import { render, staticRenderFns } from "./AudioVisual.vue?vue&type=template&id=6feea6ea&scoped=true&"
import script from "./AudioVisual.vue?vue&type=script&lang=js&"
export * from "./AudioVisual.vue?vue&type=script&lang=js&"
import style0 from "./AudioVisual.vue?vue&type=style&index=0&id=6feea6ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feea6ea",
  null
  
)

export default component.exports